import Loading from "./loadings/loading";

export default function LoadingSpinner() {
  return <Loading />;
}
